export class WebshopVoucherBatch {
  id: string;
  total: number;
  used: number;

  constructor(values: any = {}) {
    Object.assign(this as any, values);
  }
}
